export type MultilanguageText = {
  [lang: string]: string | undefined;
};

export function createDefaultMultilanguageText(text: string): MultilanguageText {
  return createMultilanguageText([DEFAULT_LANGUAGE], text);
}

export function createMultilanguageText(languages: Language[] = [DEFAULT_LANGUAGE], defaultValue: string | undefined | ((lang: Language) => string | undefined) = ''): MultilanguageText {
  const result: MultilanguageText = {};

  for (const language of languages) {
    result[language] = typeof (defaultValue) === 'function' ? defaultValue(language) : defaultValue;
  }

  return result;
}

export function getDefaultText(multilanguageText: MultilanguageText | undefined, defaultLanguage: Language = DEFAULT_LANGUAGE): string {
  if (!multilanguageText) {
    return '';
  }

  return multilanguageText[defaultLanguage] ?? multilanguageText[DEFAULT_LANGUAGE] ?? Object.values(multilanguageText)[0] ?? '';
}

export type Language = string & (
  'aa' |
  'ab' |
  'ae' |
  'af' |
  'ak' |
  'am' |
  'an' |
  'ar' |
  'as' |
  'av' |
  'ay' |
  'az' |
  'ba' |
  'be' |
  'bg' |
  'bi' |
  'bm' |
  'bn' |
  'bo' |
  'br' |
  'bs' |
  'ca' |
  'ce' |
  'ch' |
  'co' |
  'cr' |
  'cs' |
  'cu' |
  'cv' |
  'cy' |
  'da' |
  'de' |
  'dv' |
  'dz' |
  'ee' |
  'el' |
  'en' |
  'eo' |
  'es' |
  'et' |
  'eu' |
  'fa' |
  'ff' |
  'fi' |
  'fj' |
  'fo' |
  'fr' |
  'fy' |
  'ga' |
  'gd' |
  'gl' |
  'gn' |
  'gu' |
  'gv' |
  'ha' |
  'he' |
  'hi' |
  'ho' |
  'hr' |
  'ht' |
  'hu' |
  'hy' |
  'hz' |
  'ia' |
  'id' |
  'ie' |
  'ig' |
  'ii' |
  'ik' |
  'io' |
  'is' |
  'it' |
  'iu' |
  'ja' |
  'jv' |
  'ka' |
  'kg' |
  'ki' |
  'kj' |
  'kk' |
  'kl' |
  'km' |
  'kn' |
  'ko' |
  'kr' |
  'ks' |
  'ku' |
  'kv' |
  'kw' |
  'ky' |
  'la' |
  'lb' |
  'lg' |
  'li' |
  'ln' |
  'lo' |
  'lt' |
  'lu' |
  'lv' |
  'mg' |
  'mh' |
  'mi' |
  'mk' |
  'ml' |
  'mn' |
  'mr' |
  'ms' |
  'mt' |
  'my' |
  'na' |
  'nb' |
  'nd' |
  'ne' |
  'ng' |
  'nl' |
  'nn' |
  'no' |
  'nr' |
  'nv' |
  'ny' |
  'oc' |
  'oj' |
  'om' |
  'or' |
  'os' |
  'pa' |
  'pi' |
  'pl' |
  'ps' |
  'pt' |
  'qu' |
  'rm' |
  'rn' |
  'ro' |
  'ru' |
  'rw' |
  'sa' |
  'sc' |
  'sd' |
  'se' |
  'sg' |
  'si' |
  'sk' |
  'sl' |
  'sm' |
  'sn' |
  'so' |
  'sq' |
  'sr' |
  'ss' |
  'st' |
  'su' |
  'sv' |
  'sw' |
  'ta' |
  'te' |
  'tg' |
  'th' |
  'ti' |
  'tk' |
  'tl' |
  'tn' |
  'to' |
  'tr' |
  'ts' |
  'tt' |
  'tw' |
  'ty' |
  'ug' |
  'uk' |
  'ur' |
  'uz' |
  've' |
  'vi' |
  'vo' |
  'wa' |
  'wo' |
  'xh' |
  'yi' |
  'yo' |
  'za' |
  'zh' |
  'zu');

export const DEFAULT_LANGUAGE: Language = 'en';